import Router from "vue-router";
import Resume from "@/components/Resume";

function setLocale(to, from, next) {
  let { locale } = to.params;
  if (locale === "en") {
    next();
  } else {
    // Always redirect to English
    next({ path: "/en", replace: true });
  }
}

const routes = [
  {
    name: "Resume",
    path: "/:locale?",
    component: Resume,
    beforeEnter: setLocale,
    beforeUpdate: setLocale,
  },
];

const router = new Router({
  mode: "history",
  routes,
});

export default router;
